/**
 * Cor e rotulo por `tipo_notificacao` (1–8). A cor vem do `tipo_publicacao`
 * equivalente em contracts/enums.yaml, para o aviso ficar igual ao card da
 * atividade; comentario nao tem tipo de publicacao e usa a cor da marca.
 */
export type EstiloTipoNotificacao = {
  rotulo: string;
  corVar: string;
};

const NEUTRO: EstiloTipoNotificacao = { rotulo: 'Aviso', corVar: 'var(--color-primary)' };

const POR_TIPO: Record<number, EstiloTipoNotificacao> = {
  1: { rotulo: 'Recado', corVar: 'var(--color-tipo-80)' },
  2: { rotulo: 'Acesso', corVar: 'var(--color-tipo-90)' },
  3: { rotulo: 'Saúde', corVar: 'var(--color-tipo-100)' },
  4: { rotulo: 'Soninho', corVar: 'var(--color-tipo-110)' },
  5: { rotulo: 'Alimentação', corVar: 'var(--color-tipo-120)' },
  6: { rotulo: 'Higiene', corVar: 'var(--color-tipo-130)' },
  7: { rotulo: 'Resumo do dia', corVar: 'var(--color-tipo-80)' },
  8: { rotulo: 'Comentário', corVar: 'var(--color-primary)' },
};

export function estiloTipoNotificacao(tipo?: number | null): EstiloTipoNotificacao {
  if (tipo == null) return NEUTRO;
  return POR_TIPO[tipo] ?? NEUTRO;
}
